import Header from './components/Header';
import Hero from './components/Hero';
import SectionApp from './components/SectionApp';
import SectionUpdates from './components/SectionUpdates';
import SectionCards from './components/SectionCards';
import SectionIndex from './components/SectionIndex';
import SectionFeatures from './components/SectionFeatures';
import SectionContact from './components/SectionContact';
import SectionCarousel from './components/SectionCarousel';
import SectionComments from './components/SectionComments';
import SectionFaq from './components/SectionFaq';
import SectionAbout from './components/SectionAbout';
import SectionMedia from './components/SectionMedia';
import SectionRanking from './components/SectionRanking';
import SectionTopics from './components/SectionTopics';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionApp />
        <SectionUpdates />
        <SectionCards />
        <SectionIndex />
        <SectionFeatures />
        <SectionContact />
        <SectionCarousel />
        <SectionComments />
        <SectionFaq />
        <SectionAbout />
        <SectionMedia />
        <SectionRanking />
        <SectionTopics />
      </main>
      <Footer />
    </>
  );
}